import React from 'react'
import Cartitems from '../Components/CartItems/Cartitems'

const Cart = () => {
  return (
    <div>
      <Cartitems/>
    </div>
  )
}

export default Cart
